// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SmallTalk__smallTalk___xy9Z9{height:calc(100% - 56px)}.SmallTalk__smallTalk_ww_noHeader___1stVV{height:100%}.SmallTalk__smallTalkBody___eMp8o{height:100%;padding-left:300px;box-sizing:border-box;background-color:#fff;flex:1;display:flex;flex-direction:column}.SmallTalk__smallTalkBody_ww___3TNkk{padding-left:360px}.SmallTalk__smallTalkBodyColumns___IHBc_{flex:1;display:flex;overflow:hidden}.SmallTalk__smallTalkBodyColumns___IHBc_>div:first-child{border-right:1px solid #EEE}.SmallTalk__smallTalkFooter___1BFdc{border-top:1px solid #EEE;display:flex;justify-content:flex-end;padding:12px 16px}\n", ""]);
// Exports
exports.locals = {
	"smallTalk": "SmallTalk__smallTalk___xy9Z9",
	"smallTalk_ww_noHeader": "SmallTalk__smallTalk_ww_noHeader___1stVV",
	"smallTalkBody": "SmallTalk__smallTalkBody___eMp8o",
	"smallTalkBody_ww": "SmallTalk__smallTalkBody_ww___3TNkk",
	"smallTalkBodyColumns": "SmallTalk__smallTalkBodyColumns___IHBc_",
	"smallTalkFooter": "SmallTalk__smallTalkFooter___1BFdc"
};
module.exports = exports;
